/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataAttribute = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 3a1 1 0 0 1 1-1h6.001A3.99 3.99 0 0 1 12 3.354 3.99 3.99 0 0 1 14.999 2H21a1 1 0 0 1 1 1v12.012L20.812 12H20V4h-5.001A2 2 0 0 0 13 5.999v11.535c.358-.207.75-.36 1.168-.448l-1.91 4.88A1.002 1.002 0 0 1 11 20.999c0-1.106-.894-2-2-2H3a1 1 0 0 1-1-1zm9 14.534V5.999A2 2 0 0 0 9.001 4H4v12.999h5c.729 0 1.412.195 2 .535z" />
        <path d="M17.523 14 14 23h2.132l.613-1.845h3.421L20.779 23H23l-3.549-9zm2.094 5.521h-2.336l1.162-3.54z" />
      </g>
    </g>
  </Icon>
);
export { SvgDataAttribute as DataAttribute };
